/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AgencyListItem,
    AgencyListItemFromJSON,
    AgencyListItemFromJSONTyped,
    AgencyListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface AgencyListResponse
 */
export interface AgencyListResponse {
    /**
     * 
     * @type {Array<AgencyListItem>}
     * @memberof AgencyListResponse
     */
    items?: Array<AgencyListItem> | null;
    /**
     * 
     * @type {number}
     * @memberof AgencyListResponse
     */
    totalRecords?: number;
}

export function AgencyListResponseFromJSON(json: any): AgencyListResponse {
    return AgencyListResponseFromJSONTyped(json, false);
}

export function AgencyListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgencyListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(AgencyListItemFromJSON)),
        'totalRecords': !exists(json, 'totalRecords') ? undefined : json['totalRecords'],
    };
}

export function AgencyListResponseToJSON(value?: AgencyListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(AgencyListItemToJSON)),
        'totalRecords': value.totalRecords,
    };
}


